export default __webpack_public_path__ + "static/media/58t.5bb9fb20.jpg";